import React, { useEffect } from "react";

import styled from "styled-components";

import Button from "components/atoms/Button";
import Icon from "components/atoms/Icon";

const PopupWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PopupContainer = styled.div`
    position: relative;
    max-width: 400px;
    height: auto;
    background: white;
    border-radius: 12px;
    border: 1px solid #4f8698;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;
`;

const PopupContent = styled.div`
    padding: 32px 24px;
    text-align: center;
`;

const BottomBar = styled.div`
    display: flex;
    background-color: #e9f5f9;
    border-top: 1px solid #c0d9e2;
    border-radius: 0 0 12px 12px;
    overflow: hidden;
    font-size: 14px;
`;

const BottomButton = styled.button`
    flex: 1;
    padding: 16px 0;
    background: none;
    border: none;
    cursor: pointer;
    color: #444;
    font-weight: 400;

    &:hover {
        background-color: #d7edf4;
    }

    &:not(:last-child) {
        border-right: 1px solid #c0d9e2;
    }
`;

const WideButton = styled(BottomButton)`
    flex: 2;
`;

const NarrowButton = styled(BottomButton)`
    flex: 1;
`;
const PopupHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;
`;

function AbsctractPopup(props) {
    const { onClose, onClickDontShow, children, showFooter, showHeader } = props;

    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <PopupWrapper>
            <PopupContainer>
                {showHeader && (
                    <PopupHeader>
                        <Button
                            onlyIcon
                            bgColor={"var(--color-White)"}
                            hoverBgColor={"var(--color-ButtonHover4)"}
                            onClick={onClose}
                        >
                            <Icon name={"x"} color={"var(--color-SubBlack)"} />
                        </Button>
                    </PopupHeader>
                )}
                <PopupContent>{children}</PopupContent>
                {showFooter && (
                    <BottomBar>
                        <WideButton onClick={onClickDontShow}>다시 보지 않기</WideButton>
                        <NarrowButton onClick={onClose}>닫기</NarrowButton>
                    </BottomBar>
                )}
            </PopupContainer>
        </PopupWrapper>
    );
}

export default AbsctractPopup;
